module.exports = __webpack_public_path__ + "img/center front length to waist seam.8a95d6df.png";